<template>
    <div
        v-if="activeSite && $route.name !== 'site-news-config'"
        id="twitter-feed-container"
        :style="`height: ${widgetHeight}px`"
    >
        <Timeline
            sourceType="profile"
            error-message="<p>Lo sentimos pero ha ocurrido un error al cargar el feed de Twitter.<br/>Por favor recargue la página.</p>"
            :id="twitterId"
            :key="`t-${twitterId}-h-${widgetHeight}`"
            :options="{ height: widgetHeight - 5 }"
        >
            <div class="text-center">
                <b-spinner
                    label="Cargando..."
                    variant="primary"
                />
                <h5>Cargando Feed de Twitter...</h5>
            </div>
        </Timeline>
    </div>
</template>

<script>
import { Timeline } from 'vue-tweet-embed'
import { mapState } from 'vuex'

export default {
    name: 'SiteTwitterFeed',
    components: {
        Timeline
    },
    props: {
        widgetHeight: Number,
        twitterId: String
    },
    computed: {
        ...mapState([
            'activeSite'
        ])
    }
}
</script>
